"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthenticationService = exports.useAuthenticationServiceClient = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
function useAuthenticationServiceClient() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.authenticationServiceClientKey);
}
exports.useAuthenticationServiceClient = useAuthenticationServiceClient;
function useAuthenticationService() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.authenticationServiceKey);
}
exports.useAuthenticationService = useAuthenticationService;
//# sourceMappingURL=use-api.js.map